import wordsSource from "./access-code-words.txt?raw";

const WORD_PATTERN = /^[a-z]+$/u;

export const parseProjectNameWords = (source: string): readonly string[] => {
    const words = source.replaceAll("\r\n", "\n").replace(/\n$/u, "").split("\n");
    if (
        words.length < 2 ||
        words.some((word) => !WORD_PATTERN.test(word)) ||
        new Set(words).size !== words.length
    )
        throw new TypeError("Invalid project name word list");
    return Object.freeze(words);
};

const randomIndex = (
    length: number,
    cryptoImplementation: Pick<Crypto, "getRandomValues">,
): number => {
    if (!Number.isSafeInteger(length) || length < 1)
        throw new TypeError("Invalid random range");
    const range = 0x1_0000_0000;
    const ceiling = Math.floor(range / length) * length;
    const value = new Uint32Array(1);
    do cryptoImplementation.getRandomValues(value);
    while (value[0] >= ceiling);
    return value[0] % length;
};

export const createRandomProjectName = (
    words: readonly string[] = parseProjectNameWords(wordsSource),
    cryptoImplementation: Pick<Crypto, "getRandomValues"> = crypto,
): string => {
    if (
        words.length < 2 ||
        words.some((word) => !WORD_PATTERN.test(word)) ||
        new Set(words).size !== words.length
    )
        throw new TypeError("Invalid project name words");
    const firstIndex = randomIndex(words.length, cryptoImplementation);
    let secondIndex = randomIndex(words.length - 1, cryptoImplementation);
    if (secondIndex >= firstIndex) secondIndex += 1;
    return `${words[firstIndex]}-${words[secondIndex]}`;
};

export const projectNameWords = parseProjectNameWords(wordsSource);
